(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-civil-genix-rfq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rfq-form]').forEach(form => {
  if (form.dataset.rfqInitialized === 'true') return;

  const fileInput = form.querySelector('input[type="file"]');
  const dropzone = form.querySelector('[data-upload-dropzone]');
  const fileList = form.querySelector('[data-file-list]');
  const fileError = form.querySelector('[data-files-error]');
  const tradesError = form.querySelector('[data-trades-error]');
  const clearButton = form.querySelector('[data-clear-files]');
  const selectedCount = form.querySelector('[data-selected-count]');
  const selectedSize = form.querySelector('[data-selected-size]');
  const uploadedSize = form.querySelector('[data-upload-summary] > div:nth-child(3) strong');
  const overallProgress = form.querySelector('[data-overall-progress]');
  const overallPercent = form.querySelector('[data-overall-percent]');
  const processingMessage = form.querySelector('[data-processing-message]');
  const announcer = form.querySelector('[data-upload-announcer]');
  const submitButton = form.querySelector('[data-rfq-submit]');
  const submitLabel = form.querySelector('[data-submit-label]');
  const submitNote = form.querySelector('[data-submit-note]');
  const errorPanel = form.parentElement.querySelector('[data-rfq-error]');
  const errorText = errorPanel?.querySelector('[data-rfq-error-text]');
  const successPanel = form.parentElement.querySelector('[data-rfq-success]');
  const turnstileWidget = form.querySelector('[data-turnstile-widget]');
  const turnstileStatus = form.querySelector('[data-turnstile-status]');
  const documentsAvailable = form.elements.documents_available;
  const documentLink = form.elements.large_file_link;
  const tradeInputs = Array.from(form.querySelectorAll('input[name="trades[]"]'));

  const requiredElements = [
    fileInput, dropzone, fileList, fileError, tradesError, clearButton,
    selectedCount, selectedSize, uploadedSize, overallProgress,
    overallPercent, processingMessage, announcer, submitButton,
    submitLabel, submitNote, errorPanel, errorText, successPanel,
    turnstileWidget, turnstileStatus, documentsAvailable, documentLink
  ];
  if (requiredElements.some(element => !element)) return;

  errorPanel.hidden = true;
  successPanel.hidden = true;
  form.dataset.rfqInitialized = 'true';

  const card = form.parentElement;
  const fallbackWrapper = card.querySelector('[data-rfq-fallback]');
  const fallbackBody = card.querySelector('[data-fallback-body]');
  const fallbackForm = card.querySelector('#rfq-fallback-form');
  const fallbackPosted = card.querySelector('[data-fallback-posted]');
  const track = (name, params) => {
    try { if (window.uscgTrack) window.uscgTrack(name, params || {}); } catch (error) { /* noop */ }
  };
  let formStartTracked = false;
  let fallbackShownTracked = false;

  const fieldValue = name => {
    const field = form.elements[name];
    return field ? String(field.value || '').trim() : '';
  };

  const activateFallback = reason => {
    if (!fallbackBody) return;
    if (fallbackBody.hidden) {
      fallbackBody.hidden = false;
      const emailField = fallbackBody.querySelector('[data-fallback-email]');
      if (emailField && !emailField.value) emailField.value = fieldValue('email');
      fallbackBody.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (!fallbackShownTracked) {
      fallbackShownTracked = true;
      track('rfq_fallback_shown', { reason: reason || 'unknown' });
    }
  };

  const endpoint = String(form.dataset.endpoint || '').replace(/\/+$/, '');
  const turnstileSiteKey = String(form.dataset.turnstileKey || '');
  const allowedExtensions = new Set(['pdf', 'dwg', 'dxf', 'ifc', 'zip']);
  const maximumFiles = 20;
  const maximumBytes = 100 * 1024 * 1024;
  const uploadChunkBytes = 8 * 1024 * 1024;
  const originalSubmitLabel = submitLabel.textContent;
  const stageErrors = {
    initiate: 'Your submission could not be started. Please try again.',
    upload: 'Your file could not be uploaded. Retry the file.',
    finalize: 'Your files were uploaded, but the submission could not be completed. Please try again.',
    turnstile: 'Security verification expired. Please complete it again.'
  };

  let selectedFiles = [];
  let turnstileToken = '';
  let submissionBusy = false;
  let submissionId = '';
  let idempotencyKey = '';
  let submissionToken = '';
  const uploadStates = new Map();

  const selectedTradeValues = () => tradeInputs
    .filter(input => input.checked)
    .map(input => input.value);

  const syncTradeValidation = showWhenEmpty => {
    const valid = selectedTradeValues().length > 0;
    tradesError.hidden = valid || !showWhenEmpty;
    return valid;
  };

  const formatBytes = bytes => {
    if (!bytes) return '0 MB';
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const extensionOf = filename => {
    const parts = String(filename).toLowerCase().split('.');
    return parts.length > 1 ? parts.pop() : '';
  };

  const safeFilename = filename => String(filename)
    .replace(/[ -]/g, '')
    .replace(/[<>:"/\\|?*]/g, '_')
    .trim()
    .slice(0, 180) || 'project-document';

  const fileKey = file => `${file.name.toLowerCase()}::${file.size}::${file.lastModified}`;

  const randomToken = bytes => {
    const values = new Uint8Array(bytes);
    window.crypto.getRandomValues(values);
    return Array.from(values, value => value.toString(16).padStart(2, '0')).join('');
  };

  const announce = message => {
    announcer.textContent = '';
    window.setTimeout(() => { announcer.textContent = message; }, 0);
  };

  const clearError = () => {
    errorPanel.hidden = true;
    errorText.textContent = '';
  };

  const showError = message => {
    successPanel.hidden = true;
    errorText.textContent = message || form.dataset.errorServer;
    errorPanel.hidden = false;
    errorPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const clearFileError = () => {
    fileError.hidden = true;
    fileError.textContent = '';
    fileInput.removeAttribute('aria-invalid');
  };

  const showFileError = message => {
    fileError.textContent = message;
    fileError.hidden = false;
    fileInput.setAttribute('aria-invalid', 'true');
  };

  const showSuccess = () => {
    clearError();
    clearFileError();
    successPanel.hidden = false;
  };

  const validateLink = () => {
    const value = documentLink.value.trim();
    const linkRequired = documentsAvailable.value === 'Yes' && selectedFiles.length === 0;
    let message = '';

    documentLink.required = linkRequired;
    documentLink.setAttribute('aria-required', String(linkRequired));

    if (linkRequired && !value) {
      message = 'Attach project documents or provide a secure HTTPS document link.';
    } else if (value) {
      try {
        if (new URL(value).protocol !== 'https:') message = 'Use a secure HTTPS document link.';
      } catch (error) {
        message = 'Enter a valid HTTPS document link.';
      }
    }

    documentLink.setCustomValidity(message);
    return !message;
  };

  const documentRequirementSatisfied = () => {
    if (selectedFiles.length > 0) return true;
    if (documentLink.value.trim() && validateLink()) return true;
    return documentsAvailable.value === 'No';
  };

  const requiredFieldsValid = () => Array.from(form.elements).every(control => {
    if (!control.required || control.disabled || control.type === 'hidden') return true;
    return control.validity.valid;
  });

  const updateSubmitEligibility = () => {
    const linkValid = validateLink();
    const tradesValid = selectedTradeValues().length > 0;
    const consentValid = Boolean(form.elements.consent_confirmed?.checked);
    const eligible = Boolean(
      !submissionBusy &&
      turnstileToken &&
      requiredFieldsValid() &&
      tradesValid &&
      consentValid &&
      documentRequirementSatisfied() &&
      linkValid
    );

    submitButton.disabled = !eligible;
    submitButton.setAttribute('aria-disabled', String(!eligible));
    if (eligible) submitNote.textContent = form.dataset.labelReady;
  };

  const updateOverallProgress = () => {
    const total = selectedFiles.reduce((sum, file) => sum + file.size, 0);
    const uploaded = selectedFiles.reduce((sum, file) => {
      const state = uploadStates.get(fileKey(file));
      return sum + Math.min(file.size, state?.uploadedBytes || 0);
    }, 0);
    const percent = total ? Math.round(uploaded / total * 100) : 0;
    uploadedSize.textContent = formatBytes(uploaded);
    overallProgress.value = percent;
    overallProgress.textContent = `${percent}%`;
    overallPercent.textContent = `${percent}%`;
  };

  const renderFiles = () => {
    fileList.replaceChildren();

    selectedFiles.forEach(file => {
      const key = fileKey(file);
      const state = uploadStates.get(key) || { status: 'selected', progress: 0, uploadedBytes: 0 };
      const row = document.createElement('article');
      row.className = 'urfq-file-card';

      const main = document.createElement('div');
      main.className = 'urfq-file-main';
      const heading = document.createElement('div');
      heading.className = 'urfq-file-heading';
      const type = document.createElement('span');
      type.className = 'urfq-file-type';
      type.textContent = extensionOf(file.name).toUpperCase();
      const name = document.createElement('span');
      name.className = 'urfq-file-name';
      name.textContent = safeFilename(file.name);
      name.title = safeFilename(file.name);
      heading.append(type, name);

      const meta = document.createElement('div');
      meta.className = 'urfq-file-meta';
      const size = document.createElement('span');
      size.textContent = formatBytes(file.size);
      const status = document.createElement('span');
      status.className = 'urfq-file-status';
      status.textContent = state.status === 'selected'
        ? (form.dataset.fileLabelSelected || 'Selected — not uploaded')
        : state.status;
      meta.append(size, status);

      const progressWrap = document.createElement('div');
      progressWrap.className = 'urfq-file-progress';
      const progress = document.createElement('progress');
      progress.max = 100;
      progress.value = state.progress || 0;
      progress.setAttribute('aria-label', `${safeFilename(file.name)}: ${state.progress || 0}%`);
      progressWrap.append(progress);
      if (state.error) {
        const itemError = document.createElement('span');
        itemError.className = 'urfq-inline-error';
        itemError.textContent = state.error;
        progressWrap.append(itemError);
      }
      main.append(heading, meta, progressWrap);

      const actions = document.createElement('div');
      actions.className = 'urfq-file-actions';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.removeFile = key;
      remove.disabled = submissionBusy;
      remove.textContent = form.dataset.labelRemove || 'Remove';
      remove.setAttribute('aria-label', `${remove.textContent}: ${safeFilename(file.name)}`);
      actions.append(remove);

      row.append(main, actions);
      fileList.append(row);
    });

    const total = selectedFiles.reduce((sum, file) => sum + file.size, 0);
    selectedCount.textContent = String(selectedFiles.length);
    selectedSize.textContent = formatBytes(total);
    clearButton.disabled = selectedFiles.length === 0 || submissionBusy;
    updateOverallProgress();
    updateSubmitEligibility();
  };

  const validateIncomingFiles = files => {
    if (!files.length) return { valid: true };
    if (selectedFiles.length + files.length > maximumFiles) {
      return { valid: false, message: form.dataset.errorTooMany };
    }

    const existingKeys = new Set(selectedFiles.map(fileKey));
    let combinedBytes = selectedFiles.reduce((sum, file) => sum + file.size, 0);
    for (const file of files) {
      if (!allowedExtensions.has(extensionOf(file.name))) {
        return { valid: false, message: form.dataset.errorUnsupported };
      }
      if (!file.size) return { valid: false, message: form.dataset.errorEmpty };
      if (file.size > maximumBytes) {
        return { valid: false, message: form.dataset.errorFileTooLarge };
      }
      if (existingKeys.has(fileKey(file))) {
        return { valid: false, message: form.dataset.errorDuplicate };
      }
      existingKeys.add(fileKey(file));
      combinedBytes += file.size;
    }

    if (combinedBytes > maximumBytes) {
      return { valid: false, message: form.dataset.errorTooLarge };
    }
    return { valid: true };
  };

  const addFiles = filesArray => {
    const files = Array.from(filesArray || []);
    const validation = validateIncomingFiles(files);
    if (!validation.valid) {
      showFileError(validation.message);
      updateSubmitEligibility();
      return;
    }

    clearFileError();
    files.forEach(file => {
      selectedFiles.push(file);
      uploadStates.set(fileKey(file), { status: 'selected', progress: 0, uploadedBytes: 0, error: '' });
    });
    renderFiles();
    if (files.length) {
      announce(form.dataset.labelFilesAdded || 'Project documents added.');
      track('rfq_file_added', { file_count: selectedFiles.length });
    }
  };

  const collectFormMetadata = () => {
    const data = new FormData(form);
    const projectLocation = [
      data.get('project_address'), data.get('city'), data.get('state_province'), data.get('country')
    ].map(value => String(value || '').trim()).filter(Boolean).join(', ');
    const largeFileLink = String(data.get('large_file_link') || '').trim();
    const details = [
      `Project type: ${String(data.get('project_type') || '')}`,
      `Desired turnaround: ${String(data.get('desired_turnaround') || '')}`,
      data.get('estimated_construction_value') ? `Estimated construction value: ${String(data.get('estimated_construction_value'))}` : '',
      `Labor type: ${String(data.get('labor_type') || '')}`,
      `Project documents available: ${String(data.get('documents_available') || '')}`,
      largeFileLink ? `Large file or drawing link: ${largeFileLink}` : '',
      data.get('additional_notes') ? `Additional notes:\n${String(data.get('additional_notes'))}` : ''
    ].filter(Boolean).join('\n');

    return {
      fullName: String(data.get('contact_person') || ''),
      email: String(data.get('email') || ''),
      phone: String(data.get('phone') || ''),
      company: String(data.get('company_name') || ''),
      projectName: String(data.get('project_name') || ''),
      projectLocation,
      trade: selectedTradeValues().join(', '),
      bidDueDate: String(data.get('bid_due_date') || ''),
      message: details
    };
  };

  const parseResponse = async response => {
    const contentType = response.headers.get('content-type') || '';
    return contentType.includes('application/json') ? response.json() : {};
  };

  const requestError = (response, body, fallback) => {
    if (response.status === 401 || response.status === 403) return form.dataset.errorVerification;
    if (response.status === 408 || response.status === 410) return form.dataset.errorSubmissionExpired;
    if (response.status === 413) return form.dataset.errorTooLarge;
    return body?.message || fallback || form.dataset.errorServer;
  };

  const initiateSubmission = async () => {
    idempotencyKey = randomToken(16);
    submissionToken = randomToken(32);
    const hiddenToken = form.querySelector('[data-rfq-token]');
    if (hiddenToken) hiddenToken.value = submissionToken;

    const body = {
      formMetadata: collectFormMetadata(),
      files: selectedFiles.map(file => ({
        name: file.name,
        size: file.size,
        extension: extensionOf(file.name),
        mimeType: file.type || ''
      })),
      idempotencyKey,
      submissionToken,
      turnstileToken,
      consentConfirmed: Boolean(form.elements.consent_confirmed?.checked)
    };

    let response;
    try {
      response = await fetch(`${endpoint}/v1/submissions/initiate`, {
        method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
        body: JSON.stringify(body)
      });
    } catch (error) {
      throw new Error(stageErrors.initiate);
    }
    const payload = await parseResponse(response);
    if (!response.ok) throw new Error(payload?.message || stageErrors.initiate);
    if (!payload.submissionId) throw new Error(form.dataset.errorServer);
    submissionId = payload.submissionId;

    const sessions = Array.isArray(payload.files) ? payload.files : [];
    if (sessions.length !== selectedFiles.length) throw new Error(form.dataset.errorMismatch);
    return sessions;
  };

  const matchUploadSessions = sessions => {
    const remaining = [...sessions];
    return selectedFiles.map(file => {
      const index = remaining.findIndex(session =>
        session.originalFileName === file.name && Number(session.expectedSize) === file.size
      );
      if (index < 0) throw new Error(form.dataset.errorMismatch);
      const session = remaining.splice(index, 1)[0];
      if (!session.uploadUrl || !session.fileId) throw new Error(form.dataset.errorMismatch);
      return { file, session };
    });
  };

  const uploadChunk = (file, session, start) => new Promise((resolve, reject) => {
    const endExclusive = Math.min(start + uploadChunkBytes, file.size);
    const xhr = new XMLHttpRequest();
    const state = uploadStates.get(fileKey(file));
    let settled = false;
    const settle = (succeeded, value) => {
      if (settled) return;
      settled = true;
      xhr.onload = null;
      xhr.onerror = null;
      xhr.onabort = null;
      succeeded ? resolve(value) : reject(value);
    };
    xhr.open('PUT', session.uploadUrl, true);
    xhr.setRequestHeader('Content-Type', file.type || session.contentType || 'application/octet-stream');
    xhr.setRequestHeader('Content-Range', `bytes ${start}-${endExclusive - 1}/${file.size}`);
    xhr.upload.onprogress = event => {
      if (!event.lengthComputable || settled) return;
      state.uploadedBytes = start + event.loaded;
      state.progress = Math.min(99, Math.round(state.uploadedBytes / file.size * 100));
      state.status = 'Uploading';
      state.error = '';
      renderFiles();
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        state.error = '';
        state.status = 'Uploading';
        clearError();
        return settle(true, file.size);
      }
      if (xhr.status === 308) {
        const range = xhr.getResponseHeader('Range');
        const match = range?.match(/bytes=0-(\d+)/);
        state.error = '';
        return settle(true, match ? Number(match[1]) + 1 : endExclusive);
      }
      if (xhr.status === 404 || xhr.status === 410) return settle(false, new Error(form.dataset.errorSessionExpired));
      return settle(false, new Error(stageErrors.upload));
    };
    xhr.onerror = () => settle(false, new Error(stageErrors.upload));
    xhr.onabort = () => settle(false, new Error(stageErrors.upload));
    xhr.send(file.slice(start, endExclusive));
  });

  const uploadFile = async (file, session) => {
    const state = uploadStates.get(fileKey(file));
    state.status = 'Uploading';
    state.error = '';
    clearError();
    renderFiles();
    try {
      let offset = 0;
      while (offset < file.size) {
        offset = await uploadChunk(file, session, offset);
        state.uploadedBytes = offset;
        state.progress = Math.min(100, Math.round(offset / file.size * 100));
        state.error = '';
        renderFiles();
      }
      state.status = 'Completed';
      state.progress = 100;
      state.uploadedBytes = file.size;
      state.error = '';
      clearError();
      renderFiles();
    } catch (error) {
      state.status = 'Upload failed';
      state.error = error.message || stageErrors.upload;
      renderFiles();
      throw error;
    }
  };

  const finalizeSubmission = async () => {
    let response;
    try {
      response = await fetch(`${endpoint}/v1/submissions/${encodeURIComponent(submissionId)}/finalize`, {
        method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
        headers: { 'Idempotency-Key': idempotencyKey }
      });
    } catch (error) {
      throw new Error(stageErrors.finalize);
    }
    const payload = await parseResponse(response);
    if (!response.ok) throw new Error(payload?.message || stageErrors.finalize);
    return payload;
  };

  const validateBeforeSubmit = () => {
    validateLink();
    const tradesValid = syncTradeValidation(true);
    const documentsValid = documentRequirementSatisfied();
    if (!documentsValid) showFileError('Attach project documents, provide an HTTPS document link, or select that documents are unavailable.');
    form.querySelectorAll('[aria-invalid="true"]').forEach(field => field.removeAttribute('aria-invalid'));
    form.querySelectorAll(':invalid').forEach(field => field.setAttribute('aria-invalid', 'true'));
    return form.checkValidity() && tradesValid && documentsValid && Boolean(turnstileToken);
  };

  const runSubmission = async () => {
    if (submissionBusy) return;
    clearError();
    if (!validateBeforeSubmit()) {
      showError(turnstileToken ? form.dataset.errorRequired : form.dataset.errorVerification);
      form.querySelector(':invalid')?.focus();
      updateSubmitEligibility();
      return;
    }

    submissionBusy = true;
    successPanel.hidden = true;
    submitButton.disabled = true;
    submitButton.setAttribute('aria-disabled', 'true');
    submitLabel.textContent = form.dataset.labelPreparing;
    processingMessage.textContent = form.dataset.labelPreparing;
    renderFiles();

    try {
      const sessions = await initiateSubmission();
      const assignments = matchUploadSessions(sessions);
      if (assignments.length) {
        submitLabel.textContent = form.dataset.labelUploading;
        processingMessage.textContent = form.dataset.labelUploading;
        for (const assignment of assignments) await uploadFile(assignment.file, assignment.session);
      }

      submitLabel.textContent = form.dataset.labelFinalizing;
      processingMessage.textContent = form.dataset.labelFinalizing;
      await finalizeSubmission();
      selectedFiles.forEach(file => {
        const state = uploadStates.get(fileKey(file));
        if (state) state.error = '';
      });
      processingMessage.textContent = form.dataset.labelSecurityReview;
      showSuccess();
      track('rfq_submit_success', { method: 'pipeline', file_count: selectedFiles.length });
      form.hidden = true;
      successPanel.focus?.();
      successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      successPanel.hidden = true;
      showError(error.message || form.dataset.errorServer);
      processingMessage.textContent = error.message || form.dataset.errorServer;
      activateFallback('pipeline_error');
    } finally {
      submissionBusy = false;
      if (!form.hidden) {
        submitLabel.textContent = originalSubmitLabel;
        renderFiles();
        updateSubmitEligibility();
      }
    }
  };

  const loadTurnstile = () => {
    if (!endpoint || !turnstileSiteKey || !window.crypto?.getRandomValues) {
      activateFallback('not_configured');
      return;
    }

    if (!window.__uscgTurnstileLoader) {
      window.__uscgTurnstileLoader = new Promise((resolve, reject) => {
        const source = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        let script = document.querySelector('script[data-uscg-turnstile-loader]');
        let attempts = 0;
        const waitForApi = () => {
          if (window.turnstile?.render) return resolve(window.turnstile);
          attempts += 1;
          if (attempts >= 50) return reject(new Error('Cloudflare Turnstile did not initialize.'));
          window.setTimeout(waitForApi, 100);
        };
        if (!script) {
          script = document.createElement('script');
          script.src = source;
          script.async = true;
          script.defer = true;
          script.dataset.uscgTurnstileLoader = 'true';
          script.addEventListener('error', () => reject(new Error('Cloudflare Turnstile failed to load.')), { once: true });
          document.head.append(script);
        }
        waitForApi();
      });
    }

    window.__uscgTurnstileLoader.then(turnstile => {
      if (!turnstileWidget.isConnected || turnstileWidget.dataset.widgetId) return;
      const widgetId = turnstile.render(turnstileWidget, {
        sitekey: turnstileSiteKey,
        callback: token => {
          turnstileToken = token;
          clearError();
          updateSubmitEligibility();
        },
        'expired-callback': () => {
          turnstileToken = '';
          submitNote.textContent = stageErrors.turnstile;
          showError(stageErrors.turnstile);
          updateSubmitEligibility();
        },
        'error-callback': () => {
          turnstileToken = '';
          submitNote.textContent = stageErrors.turnstile;
          showError(stageErrors.turnstile);
          activateFallback('turnstile_error');
          updateSubmitEligibility();
        }
      });
      turnstileWidget.dataset.widgetId = String(widgetId);
      turnstileStatus.hidden = true;
    }).catch(() => {
      turnstileToken = '';
      activateFallback('turnstile_load_failed');
      updateSubmitEligibility();
    });
  };

  fileInput.addEventListener('change', event => {
    const files = Array.from(event.currentTarget.files || []);
    addFiles(files);
  });

  ['dragenter', 'dragover'].forEach(type => {
    dropzone.addEventListener(type, event => {
      event.preventDefault();
      dropzone.classList.add('is-dragging');
    });
  });
  ['dragleave', 'drop'].forEach(type => {
    dropzone.addEventListener(type, event => {
      event.preventDefault();
      dropzone.classList.remove('is-dragging');
    });
  });
  dropzone.addEventListener('drop', event => {
    const files = Array.from(event.dataTransfer?.files || []);
    addFiles(files);
  });

  fileList.addEventListener('click', event => {
    const button = event.target.closest('[data-remove-file]');
    if (!button || submissionBusy) return;
    const key = button.dataset.removeFile;
    selectedFiles = selectedFiles.filter(file => fileKey(file) !== key);
    uploadStates.delete(key);
    clearFileError();
    renderFiles();
    announce(form.dataset.labelRemoved || 'Project document removed.');
  });

  clearButton.addEventListener('click', () => {
    if (submissionBusy) return;
    selectedFiles = [];
    uploadStates.clear();
    clearFileError();
    renderFiles();
    announce(form.dataset.labelCleared || 'Selected project documents cleared.');
  });

  tradeInputs.forEach(input => {
    input.addEventListener('change', () => {
      syncTradeValidation(true);
      updateSubmitEligibility();
    });
  });
  form.addEventListener('input', () => {
    if (!formStartTracked) {
      formStartTracked = true;
      track('rfq_form_start');
    }
    updateSubmitEligibility();
  });
  form.addEventListener('change', () => updateSubmitEligibility());
  documentLink.addEventListener('input', () => {
    validateLink();
    updateSubmitEligibility();
  });
  documentsAvailable.addEventListener('change', () => {
    validateLink();
    updateSubmitEligibility();
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    track('rfq_submit_attempt', { method: 'pipeline' });
    void runSubmission().catch(error => {
      submissionBusy = false;
      showError(error.message || form.dataset.errorServer);
      updateSubmitEligibility();
    });
  });

  if (fallbackForm) {
    fallbackForm.addEventListener('submit', () => {
      const nameField = fallbackForm.querySelector('[data-fallback-name]');
      const phoneField = fallbackForm.querySelector('[data-fallback-phone]');
      const companyField = fallbackForm.querySelector('[data-fallback-company]');
      const messageField = fallbackForm.querySelector('[data-fallback-message]');
      if (nameField) nameField.value = fieldValue('contact_person');
      if (phoneField) phoneField.value = fieldValue('phone');
      if (companyField) companyField.value = fieldValue('company_name');
      if (messageField) {
        const lines = [
          'Website RFQ backup submission (file upload unavailable).',
          `Project name: ${fieldValue('project_name')}`,
          `Company: ${fieldValue('company_name')}`,
          `Contact person: ${fieldValue('contact_person')}`,
          `Phone: ${fieldValue('phone')}`,
          `Project address: ${fieldValue('project_address')}, ${fieldValue('city')}, ${fieldValue('state_province')}, ${fieldValue('country')}`,
          `Project type: ${fieldValue('project_type')}`,
          `Trades: ${selectedTradeValues().join(', ')}`,
          `Documents available: ${fieldValue('documents_available')}`,
          `Document link: ${fieldValue('large_file_link')}`,
          `Bid due date: ${fieldValue('bid_due_date')}`,
          `Desired turnaround: ${fieldValue('desired_turnaround')}`,
          `Estimated construction value: ${fieldValue('estimated_construction_value')}`,
          `Labor type: ${fieldValue('labor_type')}`,
          `Additional notes: ${fieldValue('additional_notes')}`
        ];
        messageField.value = lines.join('\n');
      }
      track('rfq_submit_attempt', { method: 'fallback' });
    });
  }

  if (fallbackPosted) {
    form.hidden = true;
    if (fallbackBody) fallbackBody.hidden = true;
    track('rfq_submit_success', { method: 'fallback' });
    fallbackPosted.focus?.();
  }

  processingMessage.textContent = form.dataset.labelReady || processingMessage.textContent;
  renderFiles();
  if (!fallbackPosted) loadTurnstile();
});

  } catch(e) { console.error(e); }
})();
})();
